package org.hs_soft.runmynesto.domain.model.home.options.export

import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class ApaleoSaleGroupHeadersEnum(
    val key:String,
    val isNumeric:Boolean
): TitleEnum
{
    NUMBER(
        key="number",
        isNumeric = false,
    ),
    NAME(
        key="name",
        isNumeric = false
    ),
    CHECK(
        key="checkBox",
        isNumeric=false
    );

    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                NUMBER -> strings.number
                NAME -> strings.name
                CHECK->""
            }
        }



}